import classNames from 'classnames';
import React from 'react';

import { Icon } from './Icon';

export interface LinkProps {
  icon?: string;
  variant?: 'orange-main' | 'blue-main' | 'black-main';
  italic?: boolean;
  children?: React.ReactNode;
  href?: string;
  onClick?: () => void;
  className?: string;
}

export const Link: React.FC<LinkProps> = ({
  children,
  icon = '',
  variant = 'orange-main',
  italic = true,
  ...props
}) => {
  return (
    <a
      {...props}
      className={classNames(
        'oejr-link',
        italic && 'oejr-link-italic',
        `oejr-link-${variant}`,
        props.className,
      )}
    >
      <Icon name={icon} />
      {children}
    </a>
  );
};
